import { Home } from './pages/home/index'
import { About } from './pages/about/index'
import { Contato } from './pages/contact/index'
import { Routes, Route } from 'react-router-dom' 
import { ScrollToTop } from './components/scrollToTop'
import { SelecionarTipo } from './pages/selectRole'
import { LoginPaciente } from './pages/login/loginPaciente'
import { LoginFuncionario } from './pages/login/loginFuncionario'
import { CriarContaPaciente } from './pages/createAccount/createAccountPatient'
import { CriarContaFuncionario } from './pages/createAccount/createAccountEmployee'

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contato" element={<Contato />} />
        <Route path="/institucional" element={<About />} />
        <Route path="/selecione-tipo" element={<SelecionarTipo />} />
        <Route path="/login-paciente" element={<LoginPaciente />} />
        <Route path="/login-funcionario" element={<LoginFuncionario />} />
        <Route path="/criar-conta-funcionario" element={<CriarContaFuncionario />} />
        <Route path="/criar-conta-paciente" element={<CriarContaPaciente />} />
      </Routes>
    </>
  )
}

export default App
